import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "mvList",
  props: {
    mvList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isBlod: {
      type: Boolean,
      default: false
    },
    isUnderLine: {
      type: Boolean,
      default: false
    },
    isSonger: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var router = useRouter();
    var isA = ref(false);
    var isB = ref(0);
    /* mv点击事件 */

    var mvClick = function mvClick(id) {
      router.push("/videodetail/".concat(id));
    };

    return {
      isA: isA,
      isB: isB,
      mvClick: mvClick
    };
  },
  components: {}
});